import {filter, map, mergeMap, switchMap, take} from 'rxjs/operators'
import {combineEpics, Epic} from 'redux-observable'
import {ensureKostsFetchedAction, fetchKostsAction, kostSetLoadingAction, resetKostModelsAction, setKostTemplateStrAction} from 'module/Kost/action/KostAction'
import {from} from 'rxjs'
import {fetchAllKostsAPI} from 'module/Kost/api/KostAPI'
import {catchServerError} from 'module/ConfirmDialog/component/ConfirmDialogContainer'
import {selKostFetched} from 'module/Kost/selector/KostSelector'
import {appInitAction} from 'util/ReduxUtil'
import {propertiesResponseAction} from 'module/Properties/action/PropertiesAction'
import {selPropGen, selPropGenString} from 'module/Properties/selector/selPropGen'
import {PropID} from 'module/Properties/enum/PropID'
import {selSomeKostAuswertungVisible} from 'module/Kost/selector/KostAuswertungButtonSelector'
import {log} from 'common/log'

const selShowFreigabeKostSomeActive = selPropGen(PropID.showFreigabeKost, (p) => Boolean(p && p !== 'N'))

const ensureFetchedEpic: Epic = (action$, state$) => action$.pipe(
	filter(action =>
		ensureKostsFetchedAction.match(action) ||
		(
			(appInitAction.match(action) || propertiesResponseAction.match(action))
			&&
			(selShowFreigabeKostSomeActive(state$.value) || selSomeKostAuswertungVisible(state$.value))
		),
	),
	take(1),
	filter(() => !selKostFetched(state$.value)),
	map((action) => {
		log.debug('action that initiated kost fetch:', action)
		return fetchKostsAction()
	}),
)
const fetchEpic: Epic = (action$, state$) => action$.pipe(
	filter(fetchKostsAction.match),
	switchMap(() => from(fetchAllKostsAPI()).pipe(
		mergeMap(({data}) => [resetKostModelsAction(data), kostSetLoadingAction(false)]),
		catchServerError([kostSetLoadingAction(false)]),
	)),
)

const sel = selPropGenString(PropID.evoApps_KostListTemplate);
export const templateStringPropEpic: Epic = (action$, state$) => action$.pipe(
	filter(propertiesResponseAction.match),
	mergeMap(() => {
		const templ = sel(state$.value)
		return [setKostTemplateStrAction(templ)]
	}),
)

export const KostEpic = combineEpics(ensureFetchedEpic, fetchEpic, templateStringPropEpic)